module.exports = __webpack_public_path__ + "static/media/Udemy2.26127396.JPG";